var React = require('react');

function Sun (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.2666 8.0665L7.26663 5.08317L4.91663 7.43317L7.89996 10.4165L10.2666 8.0665ZM5.66663 17.4998H0.666626V20.8332H5.66663V17.4998ZM20.6666 0.916504H17.3333V5.83317H20.6666V0.916504ZM33.0833 7.43317L30.7333 5.08317L27.75 8.0665L30.1 10.4165L33.0833 7.43317ZM27.7333 30.2665L30.7166 33.2665L33.0666 30.9165L30.0666 27.9332L27.7333 30.2665ZM32.3333 17.4998V20.8332H37.3333V17.4998H32.3333ZM19 9.1665C13.4833 9.1665 8.99996 13.6498 8.99996 19.1665C8.99996 24.6832 13.4833 29.1665 19 29.1665C24.5166 29.1665 29 24.6832 29 19.1665C29 13.6498 24.5166 9.1665 19 9.1665ZM17.3333 37.4165H20.6666V32.4998H17.3333V37.4165ZM4.91663 30.8998L7.26663 33.2498L10.25 30.2498L7.89996 27.8998L4.91663 30.8998Z","fill":"#B8AD9E"}));
}

Sun.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38","fill":"none"};

module.exports = Sun;

Sun.default = Sun;
